import PanelWrapper from "app/components/PanelWrapper";
import PublicWrapper from "app/components/PublicWrapper";
import settings from "config/environment";
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

const Purchase = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const customSchemeURL = `${settings.MOBILE_URL}${location.pathname}${location.search}`;
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile && !attempted) {
      setAttempted(true);
      window.location.href = customSchemeURL;
    }
  }, [attempted]);

  return (
    <PublicWrapper>
      <PanelWrapper>
        <div className="flex flex-col items-center justify-center text-center px-4">
          <h1>{t('Launching App...')}</h1>
          <br/>
          <Trans i18nKey="paymentsRedirect">
            If nothing happens, tap <a href={customSchemeURL}>here</a> to continue
          </Trans>
        </div>
      </PanelWrapper>
    </PublicWrapper>
  );
};

export default Purchase;
